module.exports = __webpack_public_path__ + "static/img/zanwu.046d7ec9.png";